<template>
  <v-container id="mapeo_neo" tag="section">
    <base-v-component heading="Mapeo Neo de productos del Negocio " />
    <!-- CENTRALIZADO -->
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
      v-if="esCentralizadoNeo"
    >
      <v-toolbar flat color="white">
        <v-tooltip right max-width="250px">
          <template v-slot:activator="{ on }">
            <v-btn
              class="primary"
              @click="volcarProductosNeo"
              :loading="loadingBtnNeo"
              v-on="on"
              >CENTRALIZADO: Volcar productos Neo en Mewo</v-btn
            >
          </template>
          <p max-width="150">
            CENTRALIZADO: Hace una llamada a Neo y graba todos los productos en
            la base de datos firestore de Mewo
          </p>
        </v-tooltip>
        <v-tooltip right max-width="250px">
          <template v-slot:activator="{ on }">
            <v-btn
              class="primary"
              @click="forzarPrecios"
              :loading="loadingBtnNeo"
              v-on="on"
              >Forzar precios</v-btn
            >
          </template>
          <p max-width="150">Llama a la función forzar precios de Neo</p>
        </v-tooltip>

        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="getProductosNeo">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="productosNeo"
        :loading="loading"
        :search="search"
      ></v-data-table>
    </base-material-card>

    <!-- SIN CENTRALIZAR -->
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
      v-else
    >
      <v-toolbar flat color="white">
        <v-tooltip right max-width="250px">
          <template v-slot:activator="{ on }">
            <v-btn
              class="primary"
              @click="volcarProductosNeo"
              :loading="loadingBtnNeo"
              v-on="on"
              >NO CENTRALIZADO: Volcar productos en Mewo</v-btn
            >
          </template>
          <p max-width="150">
            NO CENTRALIZADO: Hace una llamada a Neo y graba todos los productos
            de cada restaurante seleccionado en la base de datos firestore del
            restaurante correspondiente de Mewo
          </p>
        </v-tooltip>

        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-select
          v-model="restFiltrando"
          :items="$store.getters['restaurantes/getRestaurantesSelect']"
          label="RESTAURANTE NEO"
        />
        <v-spacer />
        <v-tooltip left max-width="350px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              @click="getProductosNeoRestaurantes"
              v-on="on"
            >
              <v-icon color="white">mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <p max-width="150">
            Llama a todos los restaurantes para traer sus productos y poder
            mapear. Puede demorarse
          </p>
        </v-tooltip>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="productosNeoRestaurante"
        :loading="loading"
        :search="search"
      ></v-data-table>
    </base-material-card>
    <!-- SIN CENTRALIZAR ALGUNO-->
    <v-toolbar flat color="white">
      <v-tooltip right max-width="250px">
        <template v-slot:activator="{ on }">
          <v-btn
            class="primary"
            @click="volcarProductosNeo"
            :loading="loadingBtnNeo"
            v-on="on"
            >NO CENTRALIZADO ALGUNO: Volcar productos en Mewo</v-btn
          >
        </template>
        <p max-width="150">
          Alguno centralizado: Hace una llamada a Neo y graba todos los
          productos de cada restaurante seleccionado en la base de datos
          firestore del restaurante correspondiente de Mewo
        </p>
      </v-tooltip>

      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer />
      <v-select
        v-model="restFiltrando"
        :items="$store.getters['restaurantes/getRestaurantesSelect']"
        label="RESTAURANTE NEO"
      />
      <v-spacer />
      <v-tooltip left max-width="350px">
        <template v-slot:activator="{ on }">
          <v-btn color="success" @click="getProductosNeoRestaurantes" v-on="on">
            <v-icon color="white">mdi-autorenew</v-icon>
          </v-btn>
        </template>
        <p max-width="150">
          Llama a todos los restaurantes para traer sus productos y poder
          mapear. Puede demorarse
        </p>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="productosNeoRestaurante"
      :loading="loading"
      :search="search"
    ></v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      restFiltrando: null,
      search: "",
      loading: false,
      loadingBtnNeo: false,
      headers: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
    };
  },
  computed: {
    algunoSinCentralizar() {
      console.log(this.$store.state.restaurantesArray);
      return true;
    },
    esCentralizadoNeo() {
      return this.$store.getters["app/esCentralizadoMapeoNeo"];
    },
    ...mapState({
      productosNeo: (state) => state.neo.productosNeo,
      productosNeoRestauranteTodos: (state) =>
        state.neo.productosNeoRestauranteTodos,
    }),
    productosNeoRestaurante() {
      let f = this.productosNeoRestauranteTodos.find(
        (p) => p.id == this.restFiltrando
      );
      return f ? f.productos : [];
    },
  },
  methods: {
    forzarPrecios() {
      let _vm = this;
      _vm.loadingBtnNeo = true;
      _vm.$store
        .dispatch("neo/forzarPrecios")
        .then((res) => {
          let r = res.data;
          if (r.ok) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Productos Neo forzados",
            });
            return _vm.getProductosNeo();
          } else {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: r.error,
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: e,
          });
        })
        .finally(() => {
          _vm.loadingBtnNeo = false;
        });
    },
    getProductosNeo() {
      // console.log("neo");
      let _vm = this;
      this.loading = true;
      this.$store
        .dispatch("negocios/getProductosNeo")
        .then((res) => {})
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductosNeoRestaurantes() {
      let _vm = this;
      this.loading = true;
      this.$store
        .dispatch("negocios/getProductosNeoRestaurantes")
        .then((res) => {})
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    volcarProductosNeo() {
      let _vm = this;
      _vm.loadingBtnNeo = true;
      _vm.$store
        .dispatch("neo/volcarProductosNeo")
        .then((res) => {
          let r = res.data;
          if (r.ok) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Productos Neo volcados",
            });
            return _vm.getProductosNeo();
          } else {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: r.error,
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: e,
          });
        })
        .finally(() => {
          _vm.loadingBtnNeo = false;
        });
    },
  },
};
</script>

<style>
</style>